export const messages = {
  en: {
    auditAuthOwner: {
      searchTitle: 'Search Conditions',
      authTitle: 'Owner Property Certification',
      appUserNamePlaceholder: 'Please enter associated owner name',
      idCardPlaceholder: 'Please enter associated owner ID card',
      linkPlaceholder: 'Please enter associated owner phone',
      communityName: 'Community Name',
      owner: 'Owner',
      phone: 'Phone',
      room: 'Room',
      ownerType: 'Person Type',
      idCard: 'ID Card',
      state: 'Status',
      remark: 'Audit Remark',
      createTime: 'Application Time',
      appType: 'App Type',
      operation: 'Operation',
      audit: 'Audit',
      resetPwd: 'Reset Password',
      all: 'All',
      pending: 'Pending',
      success: 'Success',
      failed: 'Failed',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    auditAuthOwner: {
      searchTitle: '查询条件',
      authTitle: '业主房产认证',
      appUserNamePlaceholder: '请输入关联业主名称',
      idCardPlaceholder: '请输入关联业主身份证',
      linkPlaceholder: '请输入关联业主手机号',
      communityName: '小区名称',
      owner: '业主',
      phone: '手机号',
      room: '房屋',
      ownerType: '人员类型',
      idCard: '身份证',
      state: '状态',
      remark: '审核说明',
      createTime: '申请时间',
      appType: '手机端类型',
      operation: '操作',
      audit: '审核',
      resetPwd: '重置密码',
      all: '全部',
      pending: '待审核',
      success: '审核成功',
      failed: '审核失败',
fetchError: '获取数据失败'
    }
  },
  'zh-TW': {
    auditAuthOwner: {
      searchTitle: '查詢條件',
      authTitle: '業主房產認證',
      appUserNamePlaceholder: '請輸入關聯業主名稱',
      idCardPlaceholder: '請輸入關聯業主身份證',
      linkPlaceholder: '請輸入關聯業主手機號',
      communityName: '小區名稱',
      owner: '業主',
      phone: '手機號',
      room: '房屋',
      ownerType: '人員類型',
      idCard: '身份證',
      state: '狀態',
      remark: '審核說明',
      createTime: '申請時間',
      appType: '手機端類型',
      operation: '操作',
      audit: '審核',
      resetPwd: '重置密碼',
      all: '全部',
      pending: '待審核',
      success: '審核成功',
      failed: '審核失敗',
      fetchError: '獲取數據失敗'
    }
  }
}